exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.html-renderer[data-v-1334661c] {\n  width: 100%;\n  box-sizing: border-box;\n\n  border: 1px solid #E5E7EB;\n  border-radius: 16px;\n  padding: 8px;\n}\n", ""]);

// exports
